

export const ACTION_TYPES = {
    ALL_PRODUCTS : 'ALL_PRODUCTS',
    ALL_CATEGORY : 'ALL_CATEGORY',
    RELATED_PRODUCTS : 'RELATED_PRODUCTS',
    ADD_CARD_LIST : "ADD_CARD_LIST ",
    REMOVE_CARD_LIST : 'REMOVE_CARD_LIST',
    INCREASE_ITEM : 'INCREASE_ITEM',
    DECREASE_ITEM : 'DECREASE_ITEM',
    PRODUCT_DETAILS : "PRODUCT_DETAILS",
    CLEAR_CART_LIST : "CLEAR_CART_LIST",
}


